import { render, staticRenderFns } from "./newlogin.vue?vue&type=template&id=10bf4a54&scoped=true"
import script from "./newlogin.vue?vue&type=script&lang=js"
export * from "./newlogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf4a54",
  null
  
)

export default component.exports